'use client';

import { Icons } from '@/components/icons';
import { siteFooterConfig } from '@/components/site-footer/site-footer.config';
import { BottomStrip } from '@/components/site-footer/bottom-strip';
import { useLocalePath } from '@/shared/hooks';
import { useT } from 'next-i18next/client';
import Link from 'next/link';
import type { FC } from 'react';

export const SiteFooter: FC = () => {
  const { t } = useT(siteFooterConfig.i18nNamespaces);
  const { to } = useLocalePath();

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10">
      <div className="container py-16">
        <div className="grid grid-cols-1 xl:grid-cols-[1fr_2fr] gap-16">
          {/* Left — brand */}
          <div>
            <Icons.mark className="size-10 text-white" />
            <p className="mt-6 text-sm text-white/40 max-w-xs leading-relaxed">
              {t('navigation:bottomNav.tagline')}
            </p>
          </div>

          {/* Right — nav columns */}
          <div className="grid grid-cols-3 gap-8">
            {/* Column 1: How we do it */}
            <div>
              <h3 className="text-white text-xs tracking-widest uppercase mb-6">
                {t('navigation:bottomNav.firstColumnHeading')}
              </h3>
              <nav className="flex flex-col gap-4">
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.caseStudies')}
                </Link>
                <Link
                  href={to('/process')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.process')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.technologies')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.integrations')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.industries')}
                </Link>
              </nav>
            </div>

            {/* Column 2: What we do */}
            <div>
              <h3 className="text-white text-xs tracking-widest uppercase mb-6">
                {t('navigation:bottomNav.secondColumnHeading')}
              </h3>
              <nav className="flex flex-col gap-4">
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.uXUiStrategyDesign')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.webDevelopment')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.iOsAppDevelopment')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.androidAppDevelopment')}
                </Link>
                <Link
                  href={to('/projects')}
                  className="text-white/50 text-sm hover:text-white transition-colors duration-150"
                >
                  {t('navigation:bottomNav.generativeAiDevelopment')}
                </Link>
              </nav>
            </div>

            {/* Column 3: Location */}
            <div>
              <h3 className="text-white text-xs tracking-widest uppercase mb-6">
                {t('navigation:bottomNav.location')}
              </h3>
              <nav className="flex flex-col gap-4">
                <span className="text-white/50 text-sm">{t('navigation:bottomNav.locationValue')}</span>
              </nav>
            </div>
          </div>
        </div>

        <BottomStrip />
      </div>
    </footer>
  );
};
